import { render } from "./product-page-component.vue?vue&type=template&id=a302fe76&scoped=true"
import script from "./product-page-component.vue?vue&type=script&lang=js"
export * from "./product-page-component.vue?vue&type=script&lang=js"

import "./product-page-component.vue?vue&type=style&index=0&id=a302fe76&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a302fe76"]])

export default __exports__